import * as React from "react";

export interface IconBadgeProps {
  icon: string;
  size?: number;
  bg: string;
  color: string;
  rounded?: boolean;
  className?: string;
}

export const IconBadge: React.FC<IconBadgeProps> = ({ icon, size = 36, bg, color, rounded = false, className }) => (
  <span
    className={className}
    style={{
      flex: "none",
      width: size,
      height: size,
      borderRadius: rounded ? "50%" : Math.round(size * 0.28),
      background: bg,
      color,
      fontSize: Math.round(size * 0.39),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <i className={icon} />
  </span>
);
